<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11H2jEK/tc-custom/9780814777046.jpg?1738123077690" alt="This image is the cover for the book Synagogue in America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Synagogue in America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“An insightful, scholarly, and comprehensive overview of the evolution and changing role of the American synagogue" (<i>Choice</i>).</b></p><p> In 1789, when George Washington was elected the first president of the United States, laymen from all six of the new nation’s Jewish congregations sent him congratulatory letters. He replied to all six—thus recognizing these religious institutions as part of the new nation. By this time, the synagogue had become the focal point of American Jewish life, a dominance that was not challenged until the twentieth century, when institutions such as Jewish community centers or Jewish philanthropic organizations claimed to be the hearts of their Jewish communities.<br/><br/> Concise yet comprehensive, <i>The Synagogue in America</i> is the first history of this all-important institution, illuminating its changing role within the American Jewish community over the course of three centuries. From Atlanta and Des Moines to Los Angeles and New Orleans, Marc Lee Raphael examines Orthodox, Reform, Conservative, and Reconstructionist synagogues. He traces the emergence of the American synagogue from the colonial period to its modern proliferation and diversification.<br/><br/> Encompassing architecture, forms of worship, rabbinic life, fundraising, creative liturgies, and feminism, <i>The Synagogue in America</i> is the go-to history for understanding the synagogue’s significance in American Jewish life. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Lee Raphael
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a6ddc52